module.exports = __webpack_public_path__ + "img/symbol_7.7b1e76da.png";